import React, { Component } from 'react'
import Converter from './Converter'
export default class Publications extends Component {
  getMarkDownContent() {
    const content = `
#Publications
[1] B. Nédelec, J. Tanke, P. Molli, A. Mostefaoui, D. Frey. [An Adaptive Peer-Sampling Protocol for Building Networks of Browsers](https://hal.inria.fr/hal-01619906). 
In World Wide Web ; éd. Springer Verlag, 2017, vol. 25.


[2] B. Nédelec, P. Molli, A. Mostefaoui. [A scalable sequence encoding for collaborative editing](https://hal.archives-ouvertes.fr/hal-01552799v1). 
In Concurrency and Computation: Practice and Experience ; éd. Wiley, 2017.

[3] Nédelec, B., Molli, P., Mostefaoui, A., & Desmontils, E. (2013,
September). [LSEQ: an adaptive structure for sequences in distributed
collaborative
editing](http://hal.univ-nantes.fr/docs/00/92/16/33/PDF/fp025-nedelec.pdf). <i>In
Proceedings of the 2013 ACM symposium on Document engineering (pp. 37-46).</i> ACM.

[4] Nédelec, B., Molli, P., Mostefaoui, A., & Desmontils,
E. (2013). [Concurrency effects over variable-size identifiers in distributed
collaborative
editing](https://hal.archives-ouvertes.fr/hal-00921655/document). <i>In
Document Changes: Modeling, Detection, Storage and Visualization (Vol. 1008,
pp. 0-7).</i>

[5] Nédelec, B., Tanke, J., Frey, D., Molli, P., Mostefaoui, A. (2015).
[Spray, an Adaptive Random Peer Sampling Protocol](https://hal.archives-ouvertes.fr/hal-01203363/file/spray.pdf). <i>Technical Report.</i>`

    return content
  }

  render() {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: Converter.getHtmlFromMarkDown(this.getMarkDownContent())
        }}
        className="textContent"
      />
    )
  }
}
